import React from 'react';
import SharedCards from '../../Shared/SharedCards/SharedCards';
import { featuresList } from './data';
const Features=()=>{
    return(
        <>
        <SharedCards 
        title="Apps features"
        desc="We want you to love working here as much as we do. To inspire our team to be creative, productive, and most importantly. "
        list={featuresList}
        />
        </>
    )
};
export default Features ;